<template>
<span class="gprice_l" :style="{color:color,fontSize:fsize,fontWeight:fweight,fontFamily:ffamily}">
  ￥<i :style="{fontSize:isize}">{{headMoney}}</i>.{{lastMoney}}
</span>
</template>
<script>

export default {
  name: '',
  components:{

  },
  props:{
    price:"",
    color:{
      type: String,
      default: "#FA4949"
    },
    fsize:{
      type: String,
      default: "12px"
    },
    fweight:{
      type: Number,
      default: 600
    },
    ffamily:{
      type:String,
      default:"PingFangSC-Semibold,PingFang SC"
    },
    isize:{
      type: String,
      default: "18px"
    },
    splitPrice:{
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      title: '',
    }
  },
  computed: {
    headMoney: function(){
      return this.getLastTwo(this.price,"head")
    },
    lastMoney: function(){
      return this.getLastTwo(this.price)
    }
  },
  methods: {
    // 转换价格
    getLastTwo: function(value,type){
        if(!value && type === "head"){
            return "0"
        }
        if(!value){
            return "00"
        }
        let str = value + "";
        let arr = str.split(".")
        
        if(arr.length > 1){
            if(type === "head"){
                return this.splitMoney(arr[0])
            }
            return arr[1].length === 2 ? arr[1] : arr[1] + "0"
        }
  
        if(type === "head"){
          return this.splitMoney(str)
        }
        return "00"
    },
    splitMoney: function(num){
      if(!this.splitPrice) return num;
      let arr = num.split("");
      if(arr.length < 4){
        return num
      }
      let str = "";
      let reverseArr = arr.reverse()
      reverseArr.forEach((element,i) => {
        str += element + ((i + 1) % 3 == 0 ? "," : "");
      });
      return str.split("").reverse().join("")
    }
  }
}
</script>
<style scoped lang='less'>
.gprice_l{
  font-size:14px;
  font-family:PingFangSC-Semibold,PingFang SC;
  font-weight:600;
  color:rgba(0,0,0,0.8);
  i{
    font-size:16px;
  }
}
</style>